import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import { config } from "../../Config/config.service"
import { Alert, CircularProgress, Grid, IconButton, Snackbar } from '@mui/material';
import DashboardCard from '../Cards/DashboardCard.component';
import { useContext, useState } from 'react';
import Button from '@mui/material/Button';
import InfoIcon from '@mui/icons-material/Info';
import { useCountry } from '../../Contexts/useCountry';
import { useUserSelection } from '../../Contexts/useUserSelection';
import useTranslation from '../Language/useTranslation';
import CountryInfo from '../Dialog/CountryInfo';
import CountryPiechart from '../Charts/CountryPiechart';
import GetAppIcon from '@mui/icons-material/GetApp';
import { CountryData } from '../../Services/apiResponseInterfaces';
import { jsPDF } from 'jspdf';
import { backendService } from '../../Services';
import { useLanguage } from '../Language/LanguageContext';


interface RightMainDrawerProps {
    open: boolean,
}

export default function RightMainDrawer({ open }: RightMainDrawerProps) {

    let countryInfoContent = null;
    const { countryInfoList } = useCountry();
    const t = useTranslation();

    const { lang } = useLanguage();

    const { selectedCountry } = useUserSelection();
    const [showInfo, setShowInfo] = useState(false);

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    // if (!selectedCountry) return (<></>);



    const handleClickInfo = (e: React.MouseEvent) => {
        setShowInfo(true);
        e.stopPropagation();
    };

    const handleCloseSnackbar = () => {
        setError(false);
    };


    const handleDownloadReport = async () => {
        if (selectedCountry) {
            setLoading(true);
            setError(false);
            try {
                await backendService.downloadReport(selectedCountry, lang);
            } catch (error) {
                setError(true);
            } finally {
                setLoading(false);
            }
        }
    };

    // extract country information for selected country
    const countryInfo = countryInfoList.find((country): country is CountryData => country.code === selectedCountry);
    const dashboardCardHeight = '110px';
    console.log("countryInfo", countryInfo);

    if (countryInfo !== undefined && countryInfo !== null) {
        countryInfoContent = <>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CountryPiechart countryInfo={countryInfo} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DashboardCard description={t.rightMainDrawer.numberOfSites} number={countryInfo.num_sites} height={dashboardCardHeight} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DashboardCard description={t.rightMainDrawer.totalSiteArea} number={countryInfo.total_site_area_in_ha} height={dashboardCardHeight} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DashboardCard description={t.rightMainDrawer.totalVegetationGainArea} number={countryInfo.total_vegetation_gain_area_in_ha} height={dashboardCardHeight} />
                </Grid>
                <Grid item xs={12} md={6}>
                    <DashboardCard description={t.rightMainDrawer.totalNumberTreesPlanted} number={countryInfo.num_trees_planted} height={dashboardCardHeight} />
                </Grid>
            </Grid>
        </>
    } else {
        countryInfoContent = <Typography variant='body1'>
            {t.rightMainDrawer.noCountryInfo}
        </Typography>
    }

    return (
        <>
            {showInfo && (
                <CountryInfo
                    setShowInfo={setShowInfo}
                    countryCode="Madagaskar"
                />
            )}
            <SidebarDrawer
                transitionDuration={0}
                variant="persistent"
                anchor="right"
                open={true}
            >
                <Box mx={2} mt={1}>
                    <>
                        <Grid container alignItems="center" justifyContent="space-between" mt={1} mb={2}>
                            <Button
                                endIcon={<InfoIcon />}
                                onClick={handleClickInfo}
                                sx={{
                                    textTransform: 'none',
                                    padding: 0,
                                    minWidth: 'auto',
                                    backgroundColor: 'transparent',
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                }}
                            >
                                <Typography variant='h6'>
                                    {t.rightMainDrawer.title}
                                </Typography>
                            </Button>

                            <Grid item>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<GetAppIcon />}
                                    onClick={handleDownloadReport}
                                    disabled={loading}
                                // sx={{ marginRight: 2 }}
                                >
                                    {loading ? <CircularProgress size={24} /> : 'Report'}

                                </Button>
                            </Grid>


                        </Grid>
                        <Snackbar open={error} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                            <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                                Failed to load report
                            </Alert>
                        </Snackbar>
                    </>
                    {countryInfoContent}
                </Box>
            </SidebarDrawer>
        </>
    )
}


const SidebarDrawer = styled(Drawer, {
})({
    flexShrink: 0,
    '& .MuiDrawer-paper': {
        width: config.general.rightDrawerWidthDesktop,
        height: config.general.leftDrawerHeight,
        boxSizing: 'border-box',
        borderRadius: "0px 0px 0px 0px"

    },
});
